module.exports = __webpack_public_path__ + "img/festa-junina.25579c35.png";